import { useEffect, useState } from "react";
import { Phone, HeartHandshake, Briefcase, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/content";

const item = "flex flex-col items-center justify-center gap-1 min-h-[56px] rounded-2xl text-[12px] font-bold leading-none transition-colors";

/** Thumb-reach action bar for phones and tablets; hides while the keyboard is up. */
export const MobileActionBar = ({ onOpenChat }) => {
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    const isField = (el) => el?.matches?.("input:not([type=checkbox]):not([type=radio]):not([type=file]), textarea, select");
    const on = (e) => { if (isField(e.target)) setTyping(true); };
    const off = () => { setTimeout(() => setTyping(isField(document.activeElement)), 50); };
    document.addEventListener("focusin", on);
    document.addEventListener("focusout", off);
    return () => { document.removeEventListener("focusin", on); document.removeEventListener("focusout", off); };
  }, []);
  return (
    <nav aria-label="Quick actions" data-testid="mobile-action-bar"
      className={`lg:hidden no-print fixed inset-x-0 bottom-0 z-40 bg-[#FBF8F1]/95 backdrop-blur-xl border-t border-[#154F49]/15 px-2 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] transition-transform duration-300 ${typing ? "translate-y-full" : "translate-y-0"}`}>
      <div className="grid grid-cols-4 gap-1.5 max-w-xl mx-auto">
        <a href={COMPANY.phoneHref} className={`${item} text-[#154F49] hover:bg-[#EDF1E6]`} data-testid="mobile-bar-call"><Phone className="w-5 h-5" /> Call</a>
        <a href="#request-care" className={`${item} bg-[#154F49] text-[#FBF8F1]`} data-testid="mobile-bar-request-care"><HeartHandshake className="w-5 h-5" /> Request Care</a>
        <a href="#apply-online" className={`${item} text-[#154F49] hover:bg-[#EDF1E6]`} data-testid="mobile-bar-apply"><Briefcase className="w-5 h-5" /> Apply</a>
        <button type="button" onClick={onOpenChat} className={`${item} text-[#154F49] hover:bg-[#EDF1E6]`} data-testid="mobile-bar-chat"><MessageCircle className="w-5 h-5" /> Ask AI</button>
      </div>
    </nav>
  );
};
